import { observable, action } from 'mobx';

class ShippingUIState {
  @observable continueButtonIsEnabled = true;

  @observable continueButtonIsLoading = false;

  @observable addressSelectionIsEnabled = true;

  @action
  public updateContinueButtonState(isEnabled: boolean): void {
    this.continueButtonIsEnabled = isEnabled;
  }

  @action
  public updateContinueLoadingButtonState(isLoading: boolean): void {
    this.continueButtonIsLoading = isLoading;
    this.continueButtonIsEnabled = !isLoading;
  }

  @action
  public updateAddressSelectionState(isEnabled: boolean): void {
    this.addressSelectionIsEnabled = isEnabled;
  }
}

export default ShippingUIState;
